import { render, staticRenderFns } from "./GreetTitle.vue?vue&type=template&id=3d9ea5f2&scoped=true"
import script from "./GreetTitle.vue?vue&type=script&lang=js"
export * from "./GreetTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9ea5f2",
  null
  
)

export default component.exports